<template>
  <div class="active">
    <!-- nav -->
    <Navbar style="height: 7.3rem" id="top" />
    <!-- banner -->
    <section class="banner">
      <img src="@/assets/images/activebanner.png" alt="" />
    </section>
    <!-- tab -->
    <div class="activeTab">
      <ul class="tabBtn" id="position">
        <li :class="tabBtn == 1 ? 'act' : ''" @click="trigger(1)">跨界合作</li>
        <li :class="tabBtn == 2 ? 'act' : ''" @click="trigger(2)">
          明星达人推荐
        </li>
      </ul>
      <ul v-if="tabBtn === 1" class="tabInfo">
        <li v-for="(item, index) in activeList" :key="index">
          <img :src="item.img_url" alt="" />
          <a :href="item.href" target="_blank">
            <p class="tit">{{ item.title }}</p>
            <p class="info">
              {{ item.info }}
            </p>
          </a>
        </li>
      </ul>
      <ul v-else-if="tabBtn === 2" class="tabInfo">
        <carousel-3d>
          <slide v-for="(item, index) in list" :key="index" :index="index">
            <!-- <img :src="i" height="270px" /> -->
            <video
              :src="item.url"
              controls="controls"
              :id="item.id"
              @click="play(item.id)"
              preload="auto"
            ></video>
          </slide>
        </carousel-3d>
        <div class="column">
          <li class="comm" v-for="(item, index) in activeList2" :key="index">
            <img :src="item.img_url" alt="" />
            <!-- <video
              src="https://video-vtrain1-rt-china.oss-cn-shanghai.aliyuncs.com/momoda/shuban/1.mp4"
              controls="controls"
            ></video> -->
          </li>
        </div>
      </ul>
    </div>
    <!-- foot -->
    <Foot />
  </div>
</template>
<script>
import Navbar from "@/components/nav.vue";
import Foot from "@/components/foot.vue";
import { activeList, activeList2 } from "@/assets/js/data.js";
export default {
  name: "active",
  components: {
    Navbar,
    Foot,
  },
  data() {
    return {
      activeList: activeList,
      activeList2: activeList2,
      tabBtn: 1,
      list: [
        {
          url: "https://video-vtrain1-rt-china.oss-cn-shanghai.aliyuncs.com/momoda/hengban/4.mp4",
          id: "vid0",
        },
        {
          url: "https://video-vtrain1-rt-china.oss-cn-shanghai.aliyuncs.com/momoda/hengban/1.mp4",
          id: "vid1",
        },
        {
          url: "https://video-vtrain1-rt-china.oss-cn-shanghai.aliyuncs.com/momoda/hengban/3.mp4",
          id: "vid2",
        },
        {
          url: "https://video-vtrain1-rt-china.oss-cn-shanghai.aliyuncs.com/momoda/hengban/5.mp4",
          id: "vid3",
        },
        {
          url: "https://video-vtrain1-rt-china.oss-cn-shanghai.aliyuncs.com/momoda/hengban/6.mp4",
          id: "vid4",
        },
      ],
    };
  },
  watch: {
    $route() {
      this.scroll();
    },
  },
  mounted() {
    this.scroll();
  },
  methods: {
    trigger(val) {
      this.tabBtn = val;
    },
    play(e) {
      this.list.forEach((item) => {
        if (e !== item.id) {
          document.getElementById(item.id).pause();
        }
      });
    },
    scroll() {
      let id = Number(this.$route.query.id);
      if (this.$route.query.id === undefined) {
        this.tabBtn = 1;
        document.getElementById("top").scrollIntoView({ behavior: "smooth" });
      } else {
        this.tabBtn = id;
        document
          .getElementById("position")
          .scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>

<style>
.carousel-3d-container {
  height: 34rem !important;
}
.carousel-3d-slider {
  width: 60% !important;
  height: 100% !important;
}
.carousel-3d-slide {
  width: 100% !important;
  height: 100% !important;
  border-width: 0 !important;
  background-color: rgba(0, 0, 0, 0.4) !important;
  border-color: rgba(0, 0, 0, 0) !important;
  padding: 1rem;
}
</style>
<style lang="scss" scoped>
.banner {
  width: 100%;
  img {
    width: 100%;
  }
}
.activeTab {
  width: 80%;
  margin: 2rem auto;
  .tabBtn {
    display: flex;
    gap: 1rem;
    li {
      width: 130px;
      height: 4rem;
      line-height: 4rem;
      border-radius: 5px;
      color: #4cbbb4;
      font-size: 1.2rem;
      text-align: center;
      border: 1px solid rgba(76, 187, 180, 1);
      cursor: pointer;
    }
    .act {
      background: #4cbbb4;
      color: #fff;
    }
  }
  .tabInfo {
    margin-top: 3rem;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 2rem;
      img {
        display: inline-block;
        width: 56%;
      }
      a {
        width: 38%;
        cursor: pointer;
        .tit {
          font-size: 2rem;
          color: #101010;
          margin-bottom: 1rem;
        }
        .info {
          font-size: 1.2rem;
          color: #666;
        }
      }
    }
    .column {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      gap: 20px;
      .comm {
        width: 25%;
        img {
          width: 100%;
        }
      }
    }
  }
}
video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  cursor: pointer;
}
</style>
